<template>
    <div class="right">
        <el-button
            class="button"
            icon="el-icon-back"
            @click="$router.go(-1)"
        >
            Go back
        </el-button>
        <el-button v-if="redirectPath"
            type="primary"
            class="right button" 
            @click="$router.push({name: redirectPath})"
            > 
                {{ redirectPath }} 
        </el-button>
    </div>
</template>

<script>
    
    export default {
        props: {
            type: {},
            redirectPath: {
                type: String,
                isRequired: true 
            }
        },
        data() {
            return {
                
            }  
        },
        methods: {
            
        }
    }
</script>

<style scoped>
    .block {
        display: inline-block;
    }

    .right {
        float: right;
    }

    .input-field {
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .button {
        margin-left: 10px;
        width: 120px;
        margin-bottom: 10px;
        margin-top: 10px;
    }


</style>



// WEBPACK FOOTER //
// src/components/Shared/ViewSharedButtons.vue